import { KettleOffOutlineIcon } from './KettleOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 15C6F7FE-65D4-4116-AF5C-7A171407E460
 * name kettle-off-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kettle-off-outline.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const TeaKettleEmptyOffIcon = KettleOffOutlineIcon;
export default TeaKettleEmptyOffIcon